// extracted by mini-css-extract-plugin
export var textInput = "_hy-0";